import { h } from 'preact'
import { tagParser } from '../../js/modules/utilities.js'

export const BandePushFidelisation = ({ title, recommendations }) => {
   return (
      <div class="bg-gray2 pt-3 pb-1 mb-3" id="bande-fidelisation-push" data-testid="bande-fidelisation-push">
         <div class="container-fluid">
            <div class="row mb-md-3">
               <div class="col-12">
                  <h2 class="mb-2">{title}</h2>
               </div>

               {recommendations.map(({ CTA, image, description }, index) => {
                  const { analytics } = CTA
                  return (
                     <div class="col-12 col-md-6 mb-2 mb-md-0">
                        <div
                           data-testid={`fidelisation-push${index + 1}`}
                           class="push-fidelisation card ob1-push ob1-push-white ob1-push-shadow-right lien-composite-before h-100"
                           data-pdb-vi={image}
                           data-pdb-zid={analytics.pdbZid}
                           data-pdb-sc={analytics.pdbSc}
                           data-pdb-idc={analytics.pdbIdc}
                           data-pdb-ta={analytics.pdbTa}
                           data-adv-canal={analytics.advCanal}
                           data-adv-cappingdata={analytics.advCappingdata}
                           data-oevent-category={analytics.oeventCategory}
                           data-oevent-action={analytics.oeventAction}
                           data-oevent-label={analytics.oeventLabel}
                           data-oevent-other={analytics.oeventOther}
                        >
                           <div class="card-header d-lg-flex">
                              <div class="img-wrap">
                                 <img src={`${image}?saveas=webp&format=400x`} alt="" loading="lazy" class="card-img-top" />
                              </div>
                              <div class="content-wrap">
                                 <p class="desc mb-0" dangerouslySetInnerHTML={{ __html: tagParser(description) }}></p>
                                 <a href={CTA.URL} class="o-link-arrow" dangerouslySetInnerHTML={{ __html: tagParser(CTA.label) }}></a>
                              </div>
                           </div>
                        </div>
                     </div>
                  )
               })}
            </div>
         </div>
      </div>
   )
}
